import React from "react"
import { SelectButton as SelectButtonPrime } from "primereact/selectbutton"

const SelectButton = React.forwardRef(
  /**
   * @param {import("primereact/selectbutton").SelectButtonProps} props
   * @param {React.Ref<HTMLDivElement>} ref
   * @returns {JSX.Element}
   */
  (props, ref) => {
    return <SelectButtonPrime ref={ref} {...props} />
  }
)

export default SelectButton
